import { type PageBottomMenuItem } from './types'

export const getActiveItem = (items?: PageBottomMenuItem[]) => items?.find((item) => item.isActive)?.key
